<div *ngIf="reportType == 'CreditNotebriefly'">
  <div class="container-fluid" id="print-section" style="margin: 0 auto; padding: 20px;">
    <table class="table table-bordered" style="width: 100%; border-collapse: collapse; font-size: 13px;">
      <thead style="text-align: center; background-color: #f2f2f2;">
        <tr>
          <th colspan="1" style="border: 1px solid #000;">Vivek Saptahik</th>
          <th colspan="4" style="border: 1px solid #000;">Issue Seller Credit Note Register</th>
          <th colspan="3" style="border: 1px solid #000;">Date: {{ currentDate | date: 'dd-MM-yyyy' }}</th>
        </tr>
        <tr>
          <th colspan="1" style="border: 1px solid #000;">Datewise</th>
          <th colspan="1" style="border: 1px solid #000;">Briefly</th>
          <th colspan="2" style="border: 1px solid #000;">
            Date From {{ startDate | date: 'dd-MM-yyyy' }} To {{ endDate | date: 'dd-MM-yyyy' }}
          </th>
          <th colspan="4" style="border: 1px solid #000;">Page No:</th>
        </tr>
        <tr>
          <th style="border: 1px solid #000;">Credit Note No</th>
          <th style="border: 1px solid #000;">CR Date</th>
          <th style="border: 1px solid #000;">Issue Seller Name</th>
          <th style="border: 1px solid #000;">Representative Name</th>
          <th style="border: 1px solid #000;">Office Representative</th>
          <th colspan="2" style="border: 1px solid #000;">Credit Note Amount</th>
          <th style="border: 1px solid #000;">Total Credit<br />Note Amount</th>
        </tr>
        <tr>
          <th colspan="5" style="border: 1px solid #000;"></th>
          <th style="border: 1px solid #000; text-align: center;">अंक परत</th>
          <th style="border: 1px solid #000; text-align: center;">अंक गहाळ/खराब</th>
          <th style="border: 1px solid #000;"></th>
        </tr>
      </thead>

      <tbody *ngFor="let data1 of advtCreditRegiInBrieflyFormBeans; let i = index">
        <tr>
          <td style="border: 1px solid #000;">{{ data1.credit_voc_no }}</td>
          <td style="border: 1px solid #000;">{{ data1.voc_date }}</td>
          <td style="border: 1px solid #000;">{{ data1.issue_Seller_Name }}</td>
          <td style="border: 1px solid #000;">{{ data1.rep_name }}</td>
          <td style="border: 1px solid #000;">{{ data1.office_rep }}</td>
          <td style="border: 1px solid #000; text-align: end;">{{ data1.tds_amt }}</td>
          <td style="border: 1px solid #000; text-align: end;">{{ data1.other_credit_amt }}</td>
          <td style="border: 1px solid #000; text-align: end;">{{ data1.credit_v_amt }}</td>
        </tr>
      </tbody>

      <tfoot>
        <tr style="font-weight: bold;">
          <td colspan="4" style="text-align: end; border: 1px solid #000;">Total:</td>
          <td style="border: 1px solid #000;"></td>
          <td style="text-align: end; border: 1px solid #000;">{{ CredittadvtInBrieflyTotaltds }}</td>
          <td style="text-align: end; border: 1px solid #000;">{{ CredittadvtInBrieflyTotalother }}</td>
          <td style="text-align: end; border: 1px solid #000;">{{ CredittadvtInBrieflyTotal }}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <!-- Buttons -->
  <div style="display: flex; justify-content: flex-end; gap: 16px; margin: 20px 22% 0 0;">
    <button class="noPrint" (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
      Export
    </button>
    <button class="noPrint" mat-raised-button color="primary" printSectionId="print-section" ngxPrint>
      Print
    </button>
    <button class="noPrint" mat-button mat-dialog-close>
      Close
    </button>
  </div>
</div>
